<template>
  <div>
    <div class="content">

      <div class="get-content">
        <div class="card">
          <div class="left">
            <van-image :src="data.sendUserInfo?.headimgurl" />
          </div>
          <div class="right">
            <div class="name">{{data.sendUserInfo?.nickname}}</div>
            <div class="text">
              赠送的评测礼物
            </div>
          </div>
        </div>
        <div class="give-text">
          嗨！我购买了一个专业评测订单赠送给你，赶紧领取测试吧！
        </div>

        <!-- 赠送内容 -->
        <div class="goods-content">
          <div class="goods-detail">
            <div class="left">
              <img :src="data?.goodsInfo?.goods_thumb_image">
            </div>
            <div class="right">
              <div class="title">{{data?.goodsInfo?.goods_subtitle}}</div>
              <div class="subhead">{{data?.goodsInfo?.goods_name}}</div>
            </div>
          </div>
          <div class="bottom">
            <div class="item">● {{data?.goodsInfo?.timu_count}}道精选问题</div>
            <div class="item">● {{data?.goodsInfo?.report_page_count}}页专业报告</div>
            <div class="item">● {{data?.goodsInfo?.goods_vr_sale_count}}人测过</div>
          </div>
        </div>
        <!-- 订单按钮 -->
          <template v-if="token">
            <div class="button disabled" v-if="!data.isSendUser && !data.isToUser&&data.sendGoodsInfo?.status!==0">订单已失效</div>
            <div v-else>
              <div
                class="button"
                @click="handleGet"
                v-if="data.sendGoodsInfo?.status===0"
              >
                点击领取
              </div>
              <div
                class="button"
                @click="confirm"
                v-if="data.sendGoodsInfo?.status===1  && !data.paperOrderInfo?.paper_order_sn"
              >
                立即测试
              </div>
              <div
                class="button"
                @click="handleContinue"
                v-if="data.paperOrderInfo?.status===0  && data.paperOrderInfo?.paper_order_sn"
              >
                继续测试
              </div>
              <div
                class="button"
                @click="handleReport"
                v-if="data.paperOrderInfo?.status===1  && data.paperOrderInfo?.paper_order_sn"
              >
                查看报告
              </div>
            </div>
          </template>

      </div>

      <div
        class="order-info"
        v-if="data?.goodsOrderInfo?.out_trade_no"
      >
        <div class="item">领取订单：{{data?.goodsOrderInfo?.out_trade_no}}</div>
        <div class="item">订单状态：{{data?.paperOrderInfo?.status===1 ? '已完成' : '未完成'}}</div>
        <div class="item">订单时间：{{data?.goodsOrderInfo?.create_time}}</div>
      </div>
      

      <!-- 平台介绍 -->
      <div class="head-title title-top">
        平台介绍
      </div>
      <div class="introduce">
        {{about}}
      </div>
      
    </div>

    <!-- 开通VIP弹窗 -->
    <VipDialog
      v-model:show="show"
      @confirm="confirm"
      buttonText="开始测试"
      :clearable="false"
    >
      <template #title>
        领取成功
      </template>
      <template #text>
        你已经成功领取了【{{data?.goodsInfo?.goods_name}}】,
        赶紧开始测试吧！
      </template>
    </VipDialog>

    <!-- 版本选择 -->
    <OptionsSelect
      v-model:show="optionVisible"
      v-model:current="optionCurrent"
      :data="options"
      :title="versionText"
      @confirm="handleOptionConfirm"
    />

  </div>

</template>

<script>
import { reactive, toRefs, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import VipDialog from "@/components/VipDialog";
import OptionsSelect from "@/components/OptionsSelect";
import { receive } from "@/api/mine";
import { putOrder, createOrder } from "@/api/goods";
import { useAgent } from "@/hooks/useAgent";
import { useStore } from "@/store";
export default {
  name: "giveDetail",
  components: {
    VipDialog,
    OptionsSelect,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { send_code } = route.query;
    const about = computed(() => store.getters.wechatInfo?.site?.site_jianjie);
    const token = computed(() => store.getters.token);
    const state = reactive({
      show: false,
      // 当前版本选择的id
      optionCurrent: undefined,
      // 版本选择显示隐藏
      optionVisible: false,
      // 版本选择的标题
      versionText: "",
      options: [],
      paper_order_sn: "",
    });
    const { md, ua, isWeChat, network, os } = useAgent();
    async function handleGet() {
      await receive({ send_code });
      state.show = true;
    }
    // 版本选择确定按钮
    function handleOptionConfirm() {
      createNewOrder();
    }

    function confirm() {
      // 开始新的订单
      if (props.data?.goodsInfo?.goods_version === 2) {
        const {
          left_version_text,
          right_version_text,
          left_version_image,
          right_version_image,
          version_text,
        } = props.data?.goodsInfo;
        state.options = [
          {
            id: 1,
            name: left_version_text,
            img: left_version_image,
          },
          {
            id: 2,
            name: right_version_text,
            img: right_version_image,
          },
        ];
        state.versionText = version_text;
        // 双版本
        state.optionVisible = true;
      } else {
        createNewOrder();
      }
    }

    // 创建新订单
    async function createNewOrder() {
      const { width, height } = window.screen;
      const data = {
        phone_model: "",
        browser_version: ua,
        screen_resolution: `${width}*${height}`,
        network,
        use_env: isWeChat ? 1 : 2,
      };

      if (os == "iOS") {
        //ios系统的处理
        data.phone_model = md.os() + md.version("iPhone");
      } else if (os == "AndroidOS") {
        //Android系统的处理
        data.phone_model = md.os() + md.version("Android");
      }

      try {
        // 下单
        const {
          data: { out_trade_no },
        } = await putOrder({
          guid: props.data?.goodsInfo?.guid,
          ...data,
          goods_version_select: state.optionCurrent,
        });
        // 创建试卷订单
        const {
          data: { paper_order_sn },
        } = await createOrder({
          out_trade_no,
        });
        state.paper_order_sn = paper_order_sn;
        goExam();
      } catch (error) {
        console.log(error);
      }
    }
    // 跳转做题页
    function goExam() {
      router.push({
        path: "/exam",
        query: {
          paper_order_sn: state.paper_order_sn,
          guid: props.data?.goodsInfo?.guid,
        },
      });
    }
    onMounted(async () => {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (!isWeixin) {
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=888"
        return false
      }
      if (props.data?.goodsInfo?.goods_version === 2) {
        const {
          left_version_text,
          right_version_text,
          left_version_image,
          right_version_image,
          version_text,
        } = props.data?.goodsInfo;
        state.options = [
          {
            id: 1,
            name: left_version_text,
            img: left_version_image,
          },
          {
            id: 2,
            name: right_version_text,
            img: right_version_image,
          },
        ];
        state.versionText = version_text;
      }
    });

    // 继续答题
    function handleContinue() {
      router.push({
        path: "/exam",
        query: {
          paper_order_sn: props.data?.paperOrderInfo?.paper_order_sn,
          guid: props.data?.goodsInfo?.guid,
        },
      });
    }
    // 跳转结果页
    function handleReport() {
      router.push({
        path: "/report",
        query: {
          paper_order_sn: props.data?.paperOrderInfo?.paper_order_sn,
          guid: props.data?.goodsInfo?.guid,
        },
      });
    }
    return {
      ...toRefs(state),
      handleGet,
      confirm,
      handleOptionConfirm,
      handleContinue,
      handleReport,
      about,
      token,
    };
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: @padding-base;
  .head-title {
    color: @theme-color;
    font-size: 18px;
    font-weight: bold;
    padding: @padding-base 0;
  }
  .title-top{
    margin-top: 20px;
  }
  .get-content {
    .card {
      .space-between();
      border-radius: 5px;
      height: 80px;
      background-color: #f0f0f0;
      padding: @padding-sm;
      .left {
        height: 60px;
        width: 60px;
        border-radius: 50%;
        overflow: hidden;
        .van-image {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .right {
        flex: 1;
        padding-left: @padding-base;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          font-size: @font-size-base;
        }
        .text {
          font-size: @font-size-lg;
          font-weight: bold;
          color: @theme-color;
        }
      }
    }
    .give-text {
      font-size: @font-size-lg;
      color: @light-black;
      line-height: 25px;
      padding: @padding-base;
    }
    .button {
      height: 38px;
      border-radius: 38px;
      background-color: @theme-color;
      color: #fff;
      line-height: 38px;
      text-align: center;
      font-size: @font-size-lg;
      letter-spacing: 5px;
      &.disabled {
        background-color: lightgray;
      }
    }
  }
  .goods-content {
    padding: 20px 0 @padding-base 0;
    .goods-detail {
      .space-between();
      .left {
        width: 120px;
        img {
          width: 100%;
          border-radius: 5px;
        }
      }
      .right {
        padding-left: @padding-sm;
        flex: 1;
        .title {
          font-size: @font-size-lg;
          line-height: 25px;
        }
        .subhead {
          color: @gray-color;
          font-size: @font-size-base;
        }
      }
    }
    .bottom {
      .space-between();
      .item {
        flex: 1;
        color: @gray-color;
        text-align: center;
        font-size: @font-size-sm;
      }
    }
  }

  .introduce {
    font-size: 14px;
    line-height: 25px;
    color: @light-black;
  }
}
.order-info {
  color: @gray-color;
  font-size: @font-size-sm;
  line-height: 25px;
  padding: @padding-sm 0;
}
</style>